<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white"> Dashboard</router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Notification Sender</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card">
                        <div class="card-body">
                            <modal :show.sync="modals.notificationModal" modal-classes="modal-dialog-centered modal-lg">
                                <div class="card bg-secondary border-0 mb-0">
                                    <div class="card-body">
                                        <PageSpinner :onloader="onloader" />
                                        <form role="form">
                                            <div class="row">
                                                <div class="col-md-12 pb-2">
                                                    <div class="row">
                                                        <div class="col">
                                                            <img v-if="ImagePathval" :src="ImagePathval"
                                                                class="img-fluid" />
                                                            <img v-else src="/img/brand/empty.png" class="img-fluid" />
                                                        </div>
                                                        <div class="col">
                                                            <ImageUploader @emitOutImgPathval="UpdateImagePathval" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Title</label>
                                                        <textarea class="form-control" v-model="NotificationTitleval"
                                                            placeholder="Enter Title"></textarea>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Notification Message</label>
                                                        <vue-editor id="NotificationMessageval"
                                                            v-model="NotificationMessageval">
                                                        </vue-editor>

                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <template slot="footer">
                                    <base-button type="default" @click="modals.notificationModal = false">Cancel
                                    </base-button>
                                    <base-button type="success" @click.prevent="SubmitNotification()">Submit
                                    </base-button>
                                </template>
                            </modal>

                            <div>
                                <div class="form-inline">
                                    <select v-model="SchoolTypeIdval" class="form-control"
                                        @change="GetSchoolsForPortal()" :disabled="SchoolTypeItems === null">
                                        <option value="0">{{ SchoolTypeItems === null ? '⏳ Loading...' : '- Select School Type - '
                                            }}</option>
                                        <option v-for="item in SchoolTypeItems" :key="item.schoolTypeId"
                                            v-bind:value="item.schoolTypeId">
                                            {{ item.schoolTypeName }}
                                        </option>
                                    </select>
                                    <select v-model="SchoolIdval" class="form-control ml-2"
                                        :disabled="SchoolItems === null">
                                        <option value="0">{{ SchoolItems === null ? '⏳ Loading...' : '- Select School -'
                                        }}</option>
                                        <option v-for="item in SchoolItems" :key="item.schoolId"
                                            v-bind:value="item.schoolId">
                                            {{ item.schoolName }}
                                        </option>
                                    </select>

                                </div>
                                <div class="justify-content-end form-inline">
                                    <button class="btn btn-success mr-3" v-on:click="OpenNewNotificationModal()">
                                        <i class="fa fa-edit"></i> New
                                    </button>
                                    <base-input class="input-group-alternative" placeholder="Search here..."
                                        addon-left-icon="fa fa-search" v-model="searchValueval">
                                    </base-input>
                                </div>
                                <div v-if="NotificationItems">
                                    <div v-for="item in NotificationItems" :key="item.classNoteId">
                                        <div class="card mt-2">
                                            <div class="card-body bg-secondary">
                                                <div class="card">
                                                    <div class="row">
                                                        <div class="col-lg-3">
                                                            <img :src="item.imagePath
                                                                " class="card-img-top" alt="...">
                                                        </div>
                                                        <div class="col-lg-9">
                                                            <h5 class="card-title" v-html="item.classNote"></h5>
                                                            <div class="card-text" v-html="item.classNoteDescription">
                                                            </div>
                                                            <div class="card-footer text-center">
                                                                <button class="btn btn-secondary btn-sm"
                                                                    v-on:click="GetById(item)">
                                                                    <i class="fa fa-edit"></i> Edit
                                                                </button>
                                                                <!-- <button class="btn btn-danger btn-sm"
                                                                    v-on:click="GetById(item.classNoteId)">
                                                                    <i class="fa fa-times"></i> Delete
                                                                </button> -->
                                                                <button class="btn btn-secondary btn-sm"
                                                                    v-on:click="OpenNotificationLesson(item.classNoteId)">
                                                                    <i class="fa fa-eye"></i> View Lessons
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>


import PageSpinner from "@/components/PageSpinner";
import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixins";
import Alert from "@/mixins/Alert.mixins"
import { VueEditor } from 'vue2-quill-editor'
import ImageUploader from "@/components/ImageUploader"
import katex from 'katex';
import 'katex/dist/katex.min.css';
window.katex = katex;

export default {
    name: "NotificationSender",
    mixins: [ValidateAccessToken, Alert],
    components: {
        PageSpinner,
        ImageUploader,
        VueEditor
    },
    data() {
        return {
            accessDetails: null,
            NotificationIdval: 0,
            NotificationTitleval: "",
            NotificationMessageval: "",
            Topicval: "",
            Screenval: "",
            SchoolTypeIdval: 0,
            SchoolIdval: 0,
            ImagePathval: null,
            searchValueval: "All",
            SchoolTypeItems: null,
            SchoolItems: null,
            NotificationItems: null,
            isModified: false,
            onloader: "none",
            editorOption: {
                debug: 'info',
                placeholder: 'Type in here',
                readonlly: true,
                theme: 'snow'
            },
            modals: {
                notificationModal: false
            }
        };
    },
    methods: {
        OpenNewNotificationModal() {
            this.isModified = false;
            this.modals.notificationModal = true
        },
        resetInput() {
            this.NotificationTitleval = "";
            this.NotificationMessageval = "";
            this.ImagePathval = null;
        },
        GetById(item) {
            this.resetInput();
            this.NotificationIdval = item.notificationId;
            this.NotificationTitleval = item.notificationTitle;
            this.NotificationMessageval = item.notificationMessage;
            this.ImagePathval = item.imagePath;
            this.isModified = true;
            this.modals.notificationModal = true;
        },
        SubmitNotification() {
            let NotificationId = this.NotificationIdval;
            let NotificationTitle = this.NotificationTitleval;
            let NotificationMessage = this.NotificationMessageval;
            let NotificationImage = this.ImagePathval;
            let Screen = this.Screenval;
            let Topic = this.Topicval;
            let SchoolTypeId=this.SchoolTypeIdval;
            let SchoolId=this.SchoolIdval;
            let userdata = {};
            this.onloader = "flex";
            let operationVal = "";
            if (this.isModified == false) {
                operationVal = "Notification/CreateNotification";
                userdata = {
                    NotificationTitle,
                    NotificationMessage,
                    NotificationId,
                    NotificationImage,
                    Screen,
                    Topic,
                    SchoolTypeId,
                    SchoolId
                }
            } else {
                operationVal = "Notification/UpdateNotification";
                userdata = {
                    NotificationId,
                    NotificationTitle,
                    NotificationMessage,
                    NotificationImage,
                    Screen,
                    Topic,
                    SchoolTypeId,
                    SchoolId
                }
            }
            this.$store
                .dispatch(operationVal, userdata)
                .then((resp) => {
                    this.onloader = "none";
                    if (resp.responseCode == '00') {
                        this.GetNotifications();
                        this.resetInput();
                        this.modals.notificationModal = false;
                        this.ShowAlertSuccess('Submitted successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        UpdateImagePathval(data) {
            this.ImagePathval = data;
        },
        GetSchoolTypeForPortal() {
            this.onloader = "flex";
            this.$store
                .dispatch("SchoolType/GetSchoolTypeForPortal")
                .then((resp) => {
                    this.SchoolTypeItems = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        GetSchoolsForPortal() {
            let SchoolTypeId = this.SchoolTypeIdval;
            if (SchoolTypeId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("School/GetSchoolsForPortal", SchoolTypeId)
                    .then((resp) => {
                        this.SchoolItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetNotifications() {
            let SchoolSubjectId = this.SchoolSubjectIdval;
            if (SchoolSubjectId > 0) {
                this.onloader = "flex";
                const userData = {
                    SchoolSubjectId
                }

                this.$store
                    .dispatch("Notification/GetNotifications", userData)
                    .then((resp) => {
                        this.NotificationItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.NotificationItems.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.classNote.toLowerCase().includes(v) ||
                                item.classNoteDescription.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.NotificationItems;
            }
        },

    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetSchoolTypeForPortal();
        } else {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        }
    },
};
</script>

<style></style>